import { fetchOCRData, increaseOCRFailedAttempt, fetchModifyOCREventTicket } from './actions';
import ocrReducer from './reducer';

export {
  fetchOCRData, increaseOCRFailedAttempt, fetchModifyOCREventTicket, ocrReducer,
};
